import { updateUserAuthDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateUserAuthCallable = getCallable(updateUserAuthDefinition);
